

if ($('.type-product h1').toArray().some(h1 => texts.some(text => $(h1).is(`:contains('${text}')`)))) {
    $(`<div class="variant-list velprst">
        <strong class="variant-list-name">${velikostPrstenu} 
            <a href="${linkHelpUs}" target="_blank">${helpUs}</a>
        </strong>
        <input class="gravirovani form-control" placeholder="${placeholderText}">
    </div>`).insertBefore('.type-detail .price.row');
}

$(document).ready(function () {
	if($('.gravirovani').length){
	  var product = $("meta[itemprop='productID']").attr('content');
	  $( ".add-to-cart-button" ).on('click', function() {
	     var productTitle = $("meta[itemprop='name']").attr('content');
	     var gravirovani = $('.gravirovani').val();
	     if(gravirovani.length > 0){

	        if (document.cookie.indexOf('product_notes') > -1 ) {
	           var productList = getCookie('product_notes');

	           if (productList .indexOf(product) === -1){
	             newProductList = productList+','+product;
	           } else {
	            newProductList = productList;
	           }
	        } else {
	              var newProductList = product;
	        }

	        var d = new Date();
	        var exdays = 1;
	        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	        var expires = "expires="+d.toUTCString();
	        document.cookie = "product_notes="+newProductList +";"+expires+ ";path=/";
	        document.cookie = "product_name_"+product +"="+productTitle+";"+expires+ ";path=/";
	        document.cookie = "product_textarea_"+product +"="+gravirovani+";"+expires+ ";path=/";
	     }
	  });

	   if (document.cookie.indexOf('product_textarea_'+product) > -1 ) {
	      var cValue = getCookie('product_textarea_'+product);
	      $('.gravirovani').val(cValue);
	   }
  	}

	  if($('#note').length){
	      if (document.cookie.indexOf('product_notes') > -1 ) {
	         $('#add-note').prop('checked',true);
	         $('#note').addClass('visible');
	         var products= getCookie('product_notes');
	         var product= products.split(',');
	         $.each( product, function( index, value ) {
	             var baseNote = $('#remark').val();
	             var productName = getCookie('product_name_'+value);
	             var productNote = getCookie('product_textarea_'+value);
	             var newNote = productName+': '+productNote;
	             if(index == '0'){
	                $('#remark').val(newNote );
	             } else {
	                $('#remark').val(baseNote+', '+newNote );
	             }
	        });
	     }
	  }

	  function getCookie(name) {
	    var value = "; " + document.cookie;
	    var parts = value.split("; " + name + "=");
	    if (parts.length == 2) return parts.pop().split(";").shift();
	 }

});